import * as React from "react"
import {Box, Typography} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";


export default function SkuAttributesNoData() {
	return <Box display="flex" justifyContent="center" gap={1.5} width={1}>
		<IconSeeker icon="empty-set" />

		<Typography variant="caption">
			SKU without Attributes
		</Typography>
	</Box>
}